import { combineReducers } from "redux";
import authReducer from "./authReducer";
import logsReducer from "./logsReducer";
import { LOGOUT } from "../actions/actionTypes";
import flightsReducer from "./flightsReducer";
import doosraCashReducer from "./doosraCashReducer";

// Combine all reducers.
const appReducer = combineReducers({
  auth: authReducer,
  logs: logsReducer,
  flights: flightsReducer,
  doosraCash: doosraCashReducer
});


const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;